import {createAction} from 'redux-act';
import {AxiosResponse} from 'axios';

import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

import {ProductType, InsuranceType, PostPurchaseInsuranceResponseSuccessType} from './types';

/**
 * Action for toggle active product
 */
export const toggleProduct = createAction<ProductType['id']>(
    'POST_PURCHASE_INSURANCE_TOGGLE_PRODUCT',
);

/**
 * Set insurance period for pay
 */
export const selectInsurancePeriod = createAction<InsuranceType['insuranceId']>(
    'POST_PURCHASE_INSURANCE_SELECT_INSURANCE',
);

/**
 * Fetch order
 */
export const getOrder = createAction(
    'POST_PURCHASE_INSURANCE_GET_ORDER',
    (token: string): Promise<AxiosResponse<PostPurchaseInsuranceResponseSuccessType>> =>
        instanceGusaBackend({
            method: 'get',
            url: ENDPOINTS.POST_PURCHASE_INSURANCE_ORDER({token}),
        }),
);
